// @flow
import LANDING_ROUTES from 'modules/landings/routes-map'
import type { MenuItem } from '../types'

export const ACTIVE_TAB_STORAGE_KEY = 'active_sidebar_tab'

export const ICON_MAP = new Map<string, string>([
  ['achievements', 'star'],
  ['agent', 'book'],
  ['blackfriday', 'fire'],
  ['blog', 'page'],
  ['books', 'externat'],
  ['cart', 'cart'],
  ['chats', 'message'],
  ['coach_courses', 'headphones'],
  ['courses', 'courses'],
  ['default', 'info'],
  ['exams', 'target'],
  ['externat', 'externat'],
  ['financialweek', 'wallet'],
  ['free_study', 'priceTag'],
  ['home', 'home'],
  ['how_it_works', 'infoInverse'],
  ['invites', 'email'],
  ['objectives', 'objective'],
  ['olympiads', 'trophy'],
  ['onboarding', 'plus'],
  ['parent', 'person'],
  ['prices', 'wallet'],
  ['product_packs', 'star'],
  ['promos', 'discount'],
  ['pupil', 'student'],
  ['pupil_events', 'clock'],
  ['referral', 'priceTag'],
  ['school_classes', 'blackBoard'],
  ['school_courses', 'page'],
  ['search', 'search'],
  ['settings', 'settings'],
  ['summercamp', 'blackBoard'],
  ['teacher_events', 'clock'],
  ['teacher_library', 'courses'],
  ['teacher_special', 'trophy'],
  ['test', 'prof'],
  ['training', 'list'],
  ['wiki', 'textbook'],
])

export const PAGE_IDS = {
  PUPIL: 'pupil',
  PARENT: 'parent',
  AGENT: 'agent',
}

export const TABS = [
  {
    title: 'Ученику',
    pageId: PAGE_IDS.PUPIL,
    highlight: false,
  },
  {
    title: 'Родителю',
    pageId: PAGE_IDS.PARENT,
    highlight: false,
  },
  {
    title: 'Учителю',
    href: '/kpk',
    pageId: PAGE_IDS.AGENT,
    highlight: false,
  },
]

export const PROFILE_MENU_ITEMS: Array<MenuItem> = [
  {
    pageId: 'home',
    title: 'Личный кабинет',
    getUrl: ({ user }) => (user.type === 'agent' ? '/teacher-dashboard' : '/dashboard/daily-plan'),
    /**
     * @param {object} match
     * @param {object} location
     */
    preventActiveUrls: () => [
      '/dashboard/objectives',
      '/dashboard/objectives/',
      '/dashboard/objectives/completed',
      '/teacher-dashboard/objectives',
      '/teacher-dashboard/objectives/',
      '/teacher-dashboard/objectives/completed',
      '/teacher-dashboard/school_classes',
      '/teacher-dashboard/school_classes/:id',
    ],
  },
  {
    pageId: 'chats',
    title: 'Чаты',
    target: '_blank',
    url: '/chats',
    hidden: ({ user }) => user.hasChats === false,
  },
  {
    pageId: 'school_classes',
    title: 'Мои классы',
    url: '/teacher-dashboard/school_classes',
    hidden: ({ user }) => user.type !== 'agent',
  },
  {
    pageId: 'achievements',
    title: 'Достижения',
    getUrl: ({ user }) => `/users/${user.id}`,
  },
  {
    pageId: 'referral',
    title: 'Учитесь бесплатно',
    url: '/referrals',
    hidden: ({ user }) => user.type === 'agent',
  },
  {
    pageId: 'promos',
    title: 'Рекомендации и скидки',
    url: LANDING_ROUTES.PROMOS,
  },
]

export const PUPIL_MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Новый учебный год',
    url: '/catalog/courses/2021',
    pageId: 'presale',
    highlight: true,
    subitems: [],
  },
  {
    title: 'Попробовать бесплатно',
    url: '/onboarding',
    pageId: 'onboarding',
    highlight: false,
    subitems: [],
    hidden: ({ user }) => user.onboardingFinished,
  },
  {
    title: 'Летний лагерь',
    url: 'https://holidays.foxford.ru',
    pageId: 'summercamp',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Поиск по Фоксфорду',
    url: '/search',
    pageId: 'search',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Курсы',
    url: '/catalog/courses',
    matchPathname: '/catalog/courses',
    pageId: 'courses',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Репетиторы',
    url: '/catalog/coach_courses',
    pageId: 'coach_courses',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Пакеты и абонементы',
    url: '/catalog/product_packs',
    pageId: 'product_packs',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Рекомендации и скидки',
    url: LANDING_ROUTES.PROMOS,
    pageId: 'promos',
    highlight: false,
    subitems: [],
    hidden: ({ user }) => user.id !== null && user.id !== 0,
  },
  {
    title: 'Экстернат и домашняя школа',
    url: 'https://externat.foxford.ru',
    pageId: 'externat',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Тесты',
    url: '/catalog/trainings',
    pageId: 'training',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Учебник',
    url: '/wiki',
    pageId: 'wiki',
    subitems: [],
  },
  {
    title: 'Блог',
    url: 'https://media.foxford.ru',
    pageId: 'blog',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Открытые мероприятия',
    url: '/catalog/events',
    pageId: 'pupil_events',
    highlight: false,
    subitems: [],
  },
]

export const PARENT_MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Новый учебный год',
    url: '/catalog/courses/2021',
    pageId: 'presale',
    highlight: true,
    subitems: [],
  },
  {
    title: 'Попробовать бесплатно',
    url: '/onboarding',
    pageId: 'onboarding',
    highlight: false,
    subitems: [],
    hidden: ({ user }) => user.onboardingFinished,
  },
  {
    title: 'Летний лагерь',
    url: 'https://holidays.foxford.ru',
    pageId: 'summercamp',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Поиск по Фоксфорду',
    url: '/search',
    pageId: 'search',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Курсы',
    url: '/catalog/courses',
    matchPathname: '/catalog/courses',
    pageId: 'courses',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Репетиторы',
    url: '/catalog/coach_courses',
    pageId: 'coach_courses',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Пакеты',
    url: '/catalog/product_packs',
    pageId: 'product_packs',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Рекомендации и скидки',
    url: LANDING_ROUTES.PROMOS,
    pageId: 'promos',
    highlight: false,
    subitems: [],
    hidden: ({ user }) => user.id !== null && user.id !== 0,
  },
  {
    title: 'Тесты',
    url: '/catalog/trainings',
    pageId: 'training',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Домашняя школа и экстернат',
    url: 'https://externat.foxford.ru',
    pageId: 'externat',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Открытые мероприятия',
    url: '/catalog/events',
    pageId: 'pupil_events',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Блог',
    url: 'https://media.foxford.ru',
    pageId: 'blog',
    highlight: false,
    subitems: [],
  },
]

export const AGENT_MENU_ITEMS: Array<MenuItem> = [
  {
    title: 'Повышение квалификации',
    url: '/catalog/teacher',
    pageId: 'teacher_library',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Летний лагерь для школьников',
    url: 'https://summer.foxford.ru',
    pageId: 'summercamp',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Курсы для школьников',
    url: '/catalog/courses',
    pageId: 'school_courses',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Руководителям ОУ',
    url: 'https://corporate.foxford.ru',
    pageId: 'product_packs',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Открытые мероприятия',
    url: '/catalog/teacher_events',
    pageId: 'teacher_events',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Тесты',
    url: '/catalog/trainings',
    pageId: 'training',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Рекомендации и скидки',
    url: LANDING_ROUTES.PROMOS,
    pageId: 'promos',
    highlight: false,
    subitems: [],
    hidden: ({ user }) => user.id !== null && user.id !== 0,
  },
  {
    title: 'Методички',
    url: 'https://books.foxford.ru/teacher',
    pageId: 'books',
    highlight: false,
    subitems: [],
  },
  {
    title: 'Учебник',
    url: '/wiki',
    pageId: 'wiki',
    subitems: [],
  },
  {
    title: 'Блог',
    url: 'https://media.foxford.ru',
    pageId: 'blog',
    highlight: false,
    subitems: [],
  },
]
